module.exports = __webpack_public_path__ + "static/typography-overview-93d36f8cf13e66418c5e40785a8cdfe5.png";